SbbPopover.small {
  --sbb-popover-max-width: 300px;
}

.sbb-popover__content {
  max-width: 300px;
  width: auto;
}

.lyne-context-help {
  display: inline-block;

  .label {
    display: inline-block;
    margin-top: 2px;
    margin-left: 2px;
    font-size: 87%;
    vertical-align: top;
  }

  &:hover {
    color: var(--sbb-color-red125);
  }
}
